import { render, staticRenderFns } from "./MainCarDetails.vue?vue&type=template&id=5032d5af&scoped=true&"
import script from "./MainCarDetails.vue?vue&type=script&lang=js&"
export * from "./MainCarDetails.vue?vue&type=script&lang=js&"
import style0 from "./MainCarDetails.vue?vue&type=style&index=0&id=5032d5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032d5af",
  null
  
)

export default component.exports